import React from 'react';
import styled from 'styled-components';

export const TypingWrapper = styled.div`
  .typing {
    display: inline-block;
    width: 1rem;
    height: 1rem;
    margin-right: 0.2rem;
    box-sizing: border-box;
    background: #fff;
    border-radius: 50%;
  }
  .typing.typing-1 {
    -webkit-animation: typing 3s infinite;
    animation: typing 3s infinite;
  }
  .typing.typing-2 {
    -webkit-animation: typing 3s 250ms infinite;
    animation: typing 3s 250ms infinite;
  }
  .typing.typing-3 {
    -webkit-animation: typing 3s 500ms infinite;
    animation: typing 3s 500ms infinite;
  }
  @-webkit-keyframes typing {
    0%,
    75%,
    100% {
      transform: translate(0, 0.25rem) scale(0.9);
      opacity: 0.5;
    }
    25% {
      transform: translate(0, -0.25rem) scale(1);
      opacity: 1;
    }
  }

  @keyframes typing {
    0%,
    75%,
    100% {
      transform: translate(0, 0.25rem) scale(0.9);
      opacity: 0.5;
    }
    25% {
      transform: translate(0, -0.25rem) scale(1);
      opacity: 1;
    }
  }
`;

function Typing() {
  return (
    <TypingWrapper data-testid="Typing">
      <span className="typing typing-1" />
      <span className="typing typing-2" />
      <span className="typing typing-3" />
    </TypingWrapper>
  );
}

export default Typing;
